import DOMPurify from "dompurify";

const DEFAULT_WHATSAPP_NUMBER = "2348180458781";

export const WHATSAPP_NUMBER =
  process.env.REACT_APP_WHATSAPP_NUMBER || DEFAULT_WHATSAPP_NUMBER;

export function sanitizeHtml(html) {
  return DOMPurify.sanitize(html || "", {
    USE_PROFILES: { html: true },
  });
}

export function buildWhatsAppUrl(message) {
  const baseUrl = `https://wa.me/${WHATSAPP_NUMBER}`;
  return message ? `${baseUrl}?text=${encodeURIComponent(message)}` : baseUrl;
}
